import React, {Component} from 'react'
import MacMasterKeyTerminalSelected from './MacMasterKeyTerminalSelected'
import MacMasterKeyTerminalInfoStepTwo from './MacMasterKeyTerminalInfoStepTwo'
import MacMasterKeyTerminalConfirmation from './MacMasterKeyTerminalConfirmation'

export default class MacMasterKeyBinding extends Component {

    constructor(props) {
        super(props);
        this.state = {
            step: 1,
            terminalID: '',
            serviceID: '',
            sequenceNumber: '',
            isServiceIDInserted: false,
        };
    }


    // go back to previous step
    prevStep = () => {
        const { step } = this.state;
        this.setState({ step: step - 1 });
    }

    // proceed to the next step
    nextStep = () => {
        const { step } = this.state;
        this.setState({ step: step + 1 });
    }

    handleValueChangeEvent = (e) => {

        if (e.split(":")[0] == 'isServiceIDInserted'){
            this.setState({isServiceIDInserted: JSON.parse(e.split(":")[1])})
            }
        if (e.split(":")[0] == 'terminalID'){
            this.setState({terminalID: e.split(":")[1]})
        }
        if (e.split(":")[0] == 'serviceID'){
            this.setState({serviceID: JSON.parse(e.split(":")[1])})
        }
        if (e.split(":")[0] == 'sequenceNumber'){
            this.setState({sequenceNumber: e.split(":")[1]})
        }

    }

    // Handle fields change
    handleChange = input => e => {
        console.log(e.target.value," handleChange master binding ",input)
            this.setState({[input]: e.target.value});
    }

    render() {
        console.log(" step ",this.state)
        const { step } = this.state;

        const { terminalID, serviceID, sequenceNumber, isServiceIDInserted} = this.state;
        const values = { terminalID, serviceID, sequenceNumber, isServiceIDInserted}

        switch(step) {
            case 1:
                return (
                    <MacMasterKeyTerminalSelected
                        nextStep={ this.nextStep }
                        handleChange={ this.handleChange }
                        handleValueChangeEvent = {this.handleValueChangeEvent}
                        values={ values }
                        isServiceIDInserted = {isServiceIDInserted}
                    />
                )
            case 2:
                return (
                    <MacMasterKeyTerminalInfoStepTwo
                        prevStep={ this.prevStep }
                        nextStep={ this.nextStep }
                        handleChange={ this.handleChange }
                        handleValueChangeEvent = {this.handleValueChangeEvent}
                        values={ values }
                    />
                )
            case 3:
                return (
                    <MacMasterKeyTerminalConfirmation
                        values={ values }
                    />
                )
            default:
            // do nothing
        }
    }
}